import React from 'react';
import { useParams, Link } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  max-width: 640px;
  margin: 0 auto;
  padding: 2.5rem 1.5rem;
`;

const Card = styled.div`
  background: rgba(2, 6, 23, 0.96);
  border-radius: 16px;
  border: 1px solid #4b5563;
  padding: 2rem 1.75rem;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.45);
`;

const Title = styled.h1`
  font-size: 1.6rem;
  margin-bottom: 0.75rem;
  color: #f9fafb;
`;

const Text = styled.p`
  margin: 0 0 0.75rem;
  font-size: 0.95rem;
  color: #e5e7eb;
`;

const Highlight = styled.p`
  margin: 0 0 1.25rem;
  font-size: 1rem;
  font-weight: 600;
  color: #facc15;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 0.75rem;
  margin-top: 1.5rem;
`;

const PrimaryButton = styled.button`
  padding: 0.6rem 1.4rem;
  border-radius: 999px;
  border: none;
  background-color: #facc15;
  color: #111827;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease, transform 0.05s ease;

  &:hover {
    background-color: #fde047;
    transform: translateY(-1px);
  }
`;

const SecondaryLink = styled(Link)`
  padding: 0.55rem 1.3rem;
  border-radius: 999px;
  border: 1px solid #4b5563;
  color: #e5e7eb;
  font-size: 0.9rem;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border-color: #9ca3af;
  }
`;

const DepositPayment: React.FC = () => {
  const { bookingId } = useParams();

  return (
    <Container>
      <Card>
        <Title>Secure your appointment</Title>
        <Text>
          Thanks for sending your appointment request. To fully lock in your time, please complete your deposit payment
          below.
        </Text>
        <Highlight>
          Deposit is handled via PayPal. This page will later be wired to a live PayPal checkout for booking ID:
          {' '}
          <span style={{ color: '#a5b4fc', fontWeight: 500 }}>{bookingId}</span>.
        </Highlight>
        <Text>
          For now, this is a placeholder screen so the flow is in place. We&apos;ll plug in live PayPal buttons here next.
        </Text>

        <ButtonRow>
          <PrimaryButton type="button">
            Pay deposit with PayPal (coming soon)
          </PrimaryButton>
          <SecondaryLink to="/">
            Back to home
          </SecondaryLink>
        </ButtonRow>
      </Card>
    </Container>
  );
};

export default DepositPayment;
